import postApi from '@/api/post/post.js'

const state = {
    post_reply_information: {},
    post_id: 0,
    // related_post_information: {},
    cursor: '',
    prev: null,
    next: null,
    text_placeholder: "",
    reply_id: 0,


    post_information: {},
    my_posts: [],
    display_posts_params: localStorage.getItem('display_posts_params') ? JSON.parse(localStorage.getItem('display_posts_params')) : {},
    post_column: [],
    active_column_id: localStorage.getItem('active_column_id')
}

const getters = {
    display_posts: state => {
        let p = []
                console.log('my_posts:'+state.my_posts.length, state.display_posts_params);
        if (state.display_posts_params.column_id > 0) {
            for (var i = 0; i < state.my_posts.length; i++) {
                if (state.my_posts[i].column_id == state.display_posts_params.column_id) {
                    p.push(state.my_posts[i])
                }
            }
        } else if (state.display_posts_params.type) {
            for (var i = 0; i < state.my_posts.length; i++) {
                if (state.my_posts[i].type === state.display_posts_params.type) {
                    p.push(state.my_posts[i])
                }
            }
        }
        return p
    },
    my_weblogs_posts: state => {
        let p = []
        for (var i = 0; i < state.my_posts.length; i++) {
            if (state.my_posts[i].type === 'weblogs') {
                p.push(state.my_posts[i])
            }
        }
        return p
    },
    my_moments_posts: state => {
        let p = []
        for (var i = 0; i < state.my_posts.length; i++) {
            if (state.my_posts[i].type === 'moments') {
                p.push(state.my_posts[i])
            }
        }
        return p
    },
    weblogs_post_column: state => {
        let p = []
        for (var i = 0; i < state.post_column.length; i++) {
            if (state.post_column[i].type === 'weblogs') {
                p.push(state.post_column[i])
            }
        }
        return p
    },
    moments_post_column: state => {
        let p = []
        for (var i = 0; i < state.post_column.length; i++) {
            if (state.post_column[i].type === 'moments') {
                p.push(state.post_column[i])
            }
        }
        return p
    },
    management_post_column: state => {
        let p = []
        for (var i = 0; i < state.post_column.length; i++) {
            if (state.post_column[i].type === 'management') {
                p.push(state.post_column[i])
            }
        }
        return p
    },
    active_column_name: state => {
        let name = '未选择栏目';
        for (var i = 0; i < state.post_column.length; i++) {
            if (state.post_column[i].id == state.active_column_id) {
                if (state.post_column[i].type === 'weblogs') {
                    name = '成长记忆-' + state.post_column[i].display_name
                } else if (state.post_column[i].type === 'moments') {
                    name = '快乐生活-' + state.post_column[i].display_name
                }
                break
            }
        }
        return name
    }
}

const mutations = {
    change_post_information(state, pInformation) {
        state.post_information = pInformation
    },
    get_my_posts(state, pInformation) {
        state.my_posts = pInformation
    },
    get_post_column(state, post_column) {
        state.post_column = post_column
    },
    change_active_column_id(state, column_id) {
        state.active_column_id = column_id
    },
    change_display_posts_params(state, display_posts_params) {
        state.display_posts_params = display_posts_params
    },
    delete_post(state, postId) {
        let index
        for (let i = 0; i < state.my_posts.length; i++) {
            if (state.my_posts[i].id === postId) {
                index = i
                break
            }
        }
        state.my_posts.splice(index, 1)
    },
    change_post(state, args) {
        let index
        for (let i = 0; i < state.my_posts.length; i++) {
            if (state.my_posts[i].id === args.id) {
                index = i
                break
            }
        }
        state.my_posts.splice(index, 1, args)
    },
    change_cover_by_url(state, url) {
        state.post_information.cover_url = url
    },
    change_post_reply_information(state, args) {
        state.post_reply_information = args
    },
    change_text_placeholder(state, text) {
        state.text_placeholder = text
    },
    change_reply_id(state, id) {
        state.reply_id = id
    },
    add_reply(state, args) {
        state.post_reply_information.results.push(args)
    },
    change_cursor(state, cursor) {
        state.cursor = cursor
    },
    change_column_setting(state, args) {
        let index
        for (let i = 0; i < state.post_column.length; i++) {
            if (state.post_column[i].id === args.id) {
                index = i
                break
            }
        }
        state.post_column.splice(index, 1, args)
    }
}

const actions = {
    get_post_information(context, postArgs) {
        postApi.get_post_info(postArgs).then((response) => {
            context.commit('change_post_information', response.data)
        })
    },
    change_cover_by_url(context, url) {
        context.commit('change_cover_by_url', url)
    },
    get_my_posts(context) {
        postApi.get_my_posts().then((response) => {
            context.commit('get_my_posts', response.data)
        })
    },
    get_post_column(context) {
        postApi.get_post_column().then((response) => {
            context.commit('get_post_column', response.data)
        })
    },
    change_active_column_id(context, column_id) {
        localStorage.setItem('active_column_id', column_id)
        context.commit('change_active_column_id', column_id)
    },
    change_display_posts_params(context, display_posts_params) {
        localStorage.setItem('display_posts_params', JSON.stringify(display_posts_params))
        context.commit('change_display_posts_params', display_posts_params)
    },
    async delete_post(context, args) {
        let res = await postApi.delete_post(args)
        if (res.status === 200 && res.data.code === 'success') {
            context.commit('delete_post', args.post_id)
        }
        return res
    },
    change_post_reply_information(context, args) {
        postApi.get_post_reply(args).then((response) => {
            context.commit('change_post_reply_information', response.data)
        })
    },
    change_post(context, args) {
        context.commit('change_post', args)
    },
    change_text_placeholder(context, text) {
        context.commit('change_text_placeholder', text)
    },
    change_reply_id(context, id) {
        context.commit('change_reply_id', id)
    },
    reply_post(context, args) {
        postApi.reply_post(args).then((response) => {
            context.commit('add_reply', JSON.parse(response.data.result).comment)
        })
    },
    reply_post_comment(context, args) {
        postApi.reply_post(args).then((response) => {
            context.commit('add_reply', JSON.parse(response.data.result).comment)
            context.dispatch('change_reply_id', 0)
            context.dispatch('change_text_placeholder', "")
        })
    },
    change_cursor(context, cursor) {
        context.commit('change_cursor', cursor)
    },
    change_column_setting(context, args) {
        context.commit('change_column_setting', args)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
